module.exports = __webpack_public_path__ + "img/symbol_9.3dab75db.png";